export default {
  paymentConfig: '支付配置',
  operationLogs: '操作日志',
  groupTodo: '业务待办',
  groupProject: '项目管理',
  groupAssets: '数据资产',
  groupAccount: '账户管理',
  groupPlatform: '平台管理',
  groupSysAdmin: '系统管理',
  groupUserSystem: '系统管理',
  groupFinance: '交易与财务',
  groupAdmin: '管理员',
  groupSuperAdmin: '超级管理员',
  bizStats: '业务数据统计',
  todoTasks: '事项待办',
  photoLive: '照片直播',
  cloudSpace: '半度云空间',
  associationManage: '协会管理',
  associationDashboard: '数据看板',
  associationHomeDecoration: '小程序装修',
  associationHomePage: '首页装修',
  associationPersonalCenter: '个人中心',
  associationBottomNavigation: '底部导航',
  associationLinkManagement: '链接管理',
  associationQuestionnaires: '问卷调查',
  associationMiniProgramConfig: '小程序配置',
  associationProfile: '商协配置',
  associationPlans: '商协会套餐',
  associationActivationRecords: '开通记录',
  associationOverview: '功能总览',
  associationJoinSettings: '入会设置',
  associationJoinApplication: '入会申请',
  associationMemberLevels: '会员级别',
  associationJoinTypes: '入会类型',
  associationMiniProgram: '协会小程序',
  associationMembers: '会员管理',
  associationFeeSettings: '会费设置',
  associationMemberList: '会员列表',
  associationMemberShowcase: '会员风采',
  associationRenewalManage: '续费管理',
  associationPaymentMethods: '缴费方式',
  associationActivities: '活动管理',
  associationActivityList: '活动列表',
  associationActivityAlbum: '照片直播',
  associationActivityRegistration: '活动报名',
  associationActivityRefund: '活动退款',
  associationDemand: '供需管理',
  associationNews: '新闻管理',
  associationArticleList: '文章管理',
  associationArticleCategories: '文章分类',
  associationFeeRecords: '缴费记录',
  conference: '会务系统',
  eventManage: '活动管理',
  votingManage: '投票管理',
  registrationManage: '问卷管理',
  venueManage: '座位配置',
  hotelManage: '酒店配置',
  receptionManage: '接待配置',
  donationManage: '捐款管理',
  cardManage: '名片管理',
  memberManage: '会员管理',
  helpManage: '帮助管理',
  memberDataOverview: '数据概览',
  memberPlan: '会员套餐',
  accountHub: '账户管理',
  myMembership: '我的会员',
  memberPlanDetail: '会员详情',
  memberPlanOrders: '套餐购买记录',
  memberPlanActivations: '开通记录',
  companyPlanManage: '会员套餐',
  referralConfig: '推荐配置',
  accountManage: '账号管理',
  rechargePlan: '充值套餐',
  myRechargePacks: '我的套餐',
  rechargeRecords: '充值记录',
  rechargeOverview: '充值数据概览',
  rechargeResourceManage: '充值套餐管理',
  myInvitations: '我的邀请',
  invitationConfig: '邀请配置',
  roleManage: '角色管理',
  permissionManage: '权限管理',
  companyManage: '公司管理',
  userManage: '用户管理',
  userVerificationConfig: '用户认证配置',
  userVerificationReviews: '认证审核记录',
  userList: '用户列表',
  resourceGrantManage: '资源授权',
  attendeeManage: '参会者管理',
  staffManage: '工作人员管理',
  orderRecords: '订单记录',
  assetManage: '财务与资产',
  messageNotifications: '消息通知',
  personalCenter: '个人中心'
}
